<template>
    <div>
<!--        The email address <strong>{{ $_.get(activity, "payload.name") }}</strong> was added by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.mailAddressAdded', {user:$_.get(activity, 'actorUser.name'), email: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "MailAddressAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
